module.exports = __webpack_public_path__ + "img/mBean.ea88c6c8.svg";